// Theme controls: a one-click switch for the sidebar, and an explicit
// three-way choice for the profile page.

import { useTheme } from '../theme';
import type { ThemePreference } from '../theme';

/** Flips between light and dark. */
export function ThemeToggle({ className = '' }: { className?: string }) {
  const { resolved, toggle } = useTheme();
  const next = resolved === 'dark' ? 'light' : 'dark';

  return (
    <button
      type="button"
      className={`btn btn-ghost btn-sm btn-icon ${className}`}
      onClick={toggle}
      title={`Switch to ${next} theme`}
      aria-label={`Switch to ${next} theme`}
    >
      {resolved === 'dark' ? '☀' : '☾'}
    </button>
  );
}

const OPTIONS: { id: ThemePreference; label: string }[] = [
  { id: 'light', label: 'Light' },
  { id: 'dark', label: 'Dark' },
  { id: 'system', label: 'System' },
];

/** Segmented control, including following the operating system. */
export function ThemePicker() {
  const { preference, setTheme } = useTheme();

  return (
    <div className="theme-toggle" role="group" aria-label="Theme">
      {OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          aria-pressed={preference === option.id}
          onClick={() => setTheme(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default ThemeToggle;
